export default __webpack_public_path__ + "static/media/symbio.19c32ce2.png";